import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AuthPageShell from "../components/AuthPageShell";

const API_BASE = process.env.REACT_APP_API_URL || "";

export default function Reset() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token") || "";
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("error");

    async function onSubmit(e) {
        e.preventDefault();
        const res = await fetch(`${API_BASE}/api/password/reset`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ token, password }),
        });
        const data = await res.json().catch(() => ({}));
        setMessage(res.ok ? "Пароль успешно изменен" : (data.error || "Ошибка"));
        setMessageType(res.ok ? "success" : "error");
    }

    return (
        <AuthPageShell>
            <h1 className="auth-page-title">Сброс пароля</h1>
            <form onSubmit={onSubmit} className="auth-form">
                <input
                    placeholder="Новый пароль"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="ui-input"
                    required
                />
                <button className="toolbar-btn" type="submit">
                    Сохранить новый пароль
                </button>
            </form>
            <div className="auth-links">
                <Link to="/login" className="btn-outline">Назад ко входу</Link>
            </div>
            {message && (
                <p className={messageType === "success" ? "form-message--success" : "form-message"}>
                    {message}
                </p>
            )}
        </AuthPageShell>
    );
}
